import React from 'react';
import { useNavigate } from 'react-router-dom';

import { NotFoundView } from './NotFound.view';

/**
 * 404, the container. Navigation only.
 *
 * Everything visual lives in `NotFound.view.jsx`, which is pure, so the state
 * explorer can mount the real screen without a router.
 *
 * `NotFound.css` is gone: nothing else imported it and the page no longer emits
 * one of its class names.
 */

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return <NotFoundView onGoBack={handleGoBack} />;
};

export default NotFound;
